import _ from 'lodash'
import { useSelector } from 'react-redux'

const CheckoutErrorsPanel = () => {
  const errors = useSelector(state => state.errors)

  // Filter out null/undefined values and technical errors from errors
  const errorsPresent = _(errors)
    .omitBy(_.isNull)
    .omitBy((value, key) => {
      // Filter out technical/internal errors that shouldn't be shown to users
      const technicalErrors = ['Utf8Encode', 'Utf8Decode', 'utf8Encode', 'utf8Decode']
      return technicalErrors.includes(key)
    })
    .value()

  // Filter out shipping rate errors that are already displayed in the dedicated shipping error component
  const filteredErrors = _(errorsPresent)
    .omitBy((value, key) => key === 'shipping_rates')
    .value()

  const hasGeneralErrors = Object.values(filteredErrors).length > 0

  if (!hasGeneralErrors) {
    return null
  }

  return (
    <div className="alert alert-danger p-md" role="alert">
      <div style={{ fontWeight: 700, marginBottom: '10px' }}>
        We encountered one or more errors while processing your order for checkout. Please review them below and reach
        out to our support team if you need assistance.
      </div>
      {Object.entries(filteredErrors).map(([key, val], i) => {
        if (val) {
          return (
            <div style={{ marginBottom: '15px' }} key={i}>
              {key.includes('_') ? (
                <>{errors[key]?.message ?? errors[key] ?? val}</>
              ) : (
                <>
                  <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>{' '}
                  {errors[key]?.message ?? errors[key] ?? val}
                </>
              )}
            </div>
          )
        }
      })}
    </div>
  )
}

export default CheckoutErrorsPanel
